var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamageMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 484 409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 285,
    width: 130,
    height: 31,
    rx: 3.4,
    ry: 3.4,
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.6,138.6c5.9-9.6,2.5-20.3,0-25.6-1-2.1-3.1-3.5-5.4-3.5h-43.7l-40-73c-9-16-31-16-31-16h-205.5s-22,0-31,16l-40,73H22.3c-2.3,0-4.5,1.3-5.4,3.5-2.5,5.4-5.9,16.1,0,25.6,1.1,1.8,3,2.9,5.1,2.9h26.6s-16,26.4-24.1,41.6c-3,5.5-4.6,11.6-4.7,17.9l-2.8,103.8c0,.4,0,.9,0,1.3-.2,2.8-.3,16.8,13.4,26.7,6.4,4.6,14.1,6.8,21.9,6.8h375c7.8,0,15.5-2.3,21.9-6.8,13.7-9.9,13.6-23.9,13.4-26.7,0-.4,0-.9,0-1.3l-2.8-103.8c-.2-6.3-1.8-12.4-4.7-17.9-8.1-15.2-24.1-41.6-24.1-41.6h26.6c2.1,0,4-1.1,5.1-2.9ZM124.8,224.4c-1.3.4-2.7.6-4.1.6l-44.3-1c-11.6,0-22.4-4.9-28-14.7-1.5-2.7-2.5-5.4-2.4-8,0,0,0-.3,0-.7,1.8-13.3,15.7-21.8,29-17.9,4.5,1.3,9.9,3.3,16.3,6.6l33,15.5c3.8,1.8,6.7,5.1,7.6,9,.9,3.9,0,8.3-7.3,10.6ZM68.9,156c-.2,0-.4,0-.6,0-4.5-.4-7-5.6-4.7-9.5l56.5-99.6c0-3.8,3.1-6.9,6.9-6.9h224.3c3.8,0,6.9,3.1,6.9,6.9l58.4,99.5c2.3,3.9-.1,9.2-4.6,9.6-.2,0-.4,0-.6,0H68.9ZM434.3,200.6c0,.5,0,.7,0,.7,0,2.5-.9,5.3-2.4,8-5.5,9.8-16.4,14.7-28,14.7l-44.3,1c-1.4,0-2.8-.2-4.1-.6-7.3-2.3-8.2-6.7-7.3-10.6.9-4,3.8-7.3,7.6-9l33-15.5c6.4-3.2,11.8-5.3,16.3-6.6,13.3-3.8,27.2,4.6,29,17.9Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,350h-35.6s-14.4-3-19.4-8v39.9c0,1.1,0,2.3,0,3.4s.3,4.7,4.1,4.7h46.5s1.4.6,2.9-1.1,1.5-2.6,1.5-4.1v-34.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,350h35.6s14.4-3,19.4-8v39.9c0,1.1,0,2.3,0,3.4s-.3,4.7-4.1,4.7h-46.5s-1.4.6-2.9-1.1-1.5-2.6-1.5-4.1v-34.9Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.8,82.4c-5,.9-9.8,3.6-12.6,7.7s-3.6,10-1.2,14.4c3.3,6.1,10.8,8.2,17.6,9.8,3.2.7,6.4,1.5,9.6.8,3.5-.7,6.6-3.1,8.5-6.2s2.8-6.7,3-10.3c.2-3.4-.2-6.9-2.3-9.6-4.8-6.4-15.3-8.1-22.6-6.7Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,85.5c.4-1.7,1.9-4.8,3.1-6.1,1.3-1.4,3-2.8,2.7-4.7,0-.5-.3-1-.4-1.5s.2-1.1.7-1.3c.3,0,.5,0,.8,0,2.1.5,4.2,1,6.3,1.6,2,.5,4.7.8,5.7-1.1,1.1-1.8-.5-4.4.6-6.2.6-1,1.9-1.4,3-1.8s2.3-1.2,2.4-2.4",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.6,92.6c3-.3,5.8-1.3,8.3-2.9.6-.4,1.1-.8,1.8-.9,1.2-.3,2.5.4,3.7.6,2.9.3,5.2-2.3,6.9-4.7s4.1-5,7-4.6c.7-2.7-1-6,1-8,.7-.7,1.7-1,2.7-1.3,5.9-1.4,12.3-2,17.2-5.6",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,104.8l10.4,5.1c.5.3,1.1.5,1.7.6,2.2.2,3.5-2.7,5.7-3.3,2.6-.7,4.7,2,6.3,4.1,2.3,2.9,6,7.3,9.3,9.1s7.4.7,10.6.7",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2,148.6c-3.3-3.7-5.3-8.6-5.5-13.5,0-.8,0-1.7-.4-2.5-.4-.7-1-1.2-1.7-1.7-2.9-2.1-5.9-4-8.1-6.8s-3.1-6.9-1.2-9.9",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,109.4c-.8,3.9-1.8,7-5.6,8.3s-8.3,3.2-11.7,6.5c-1.5,1.4-2.9,3.1-3.7,5",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,98c-1.8-2.3-4-4.3-6.4-6-.5-.4-1-.7-1.2-1.3-.1-.4-.1-.8,0-1.2.2-2.7.4-5.3.6-8,0-1.4.2-2.8-.6-3.9-.8-1.3-2.4-1.7-3.8-2.3-3.8-1.7-6.5-5.5-6.9-9.6",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,91.5c-.4,3.3-2.3,9.3-5.5,10.5-1.2.4-2.4.3-3.7.3-2.7,0-5.5.5-8.1,1.4-.6.2-1.3.5-1.8,1-.8.9-.8,2.3-.7,3.5.4,3.9,1.6,8,.6,11.8-1.5,5.8-7.4,9.2-12.9,11.8-.2-.4-.5-.8-.7-1.2",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.5,91.5c-4.6.9-10.5.9-15.2.1-1.8-.3-3.6-.8-5.4-.4-1.6.4-3,1.4-4.6,1.9-2.4.8-5,.5-7.4-.4s-4.5-2.3-6.6-3.7",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.1,81.3c.7-2-.7-4.2-2.6-5.2s-4.1-1-6.2-1c.2-2.4-1.4-4.9-3.7-5.6-1.5-.5-3.3-.3-4.4-1.4-.6-.6-.8-1.5-1.1-2.3-1.1-3.5-3.1-6.7-5.6-9.3-1.8-1.9-4-3.6-5-6-1.5-3.5-.2-7.7-1.8-11.2",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.8,46.1c1,7.2,5.7,13.8,12.2,17,1.1.5,2.3,1.1,3,2.1,2,3.4-2.8,7,.5,10.2s5.6-.1,7.2-3.9c3.8-7.4,6-.6,6.8,1.9",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,89.5c-.7.2-1.3.4-1.9.7-1.4,1-1.7,3-1.8,4.7,0,1.5,0,3,.7,4.3.9,2,2.9,3.4,5,4.1s4.3.8,6.5.8c2.9,0,6.1,0,8.2-2,.8-.8,1.4-1.8,1.9-2.8.8-1.8,2.1-5.9.9-7.9s-2.1-1.1-3.8-1.2c-5.4-.4-10.2-2.1-15.7-.8Z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2,113.8c0-3-.4-6-.8-9,0-.2,0-.5-.2-.7-.1-.2-.4-.4-.6-.5-2.5-1.5-5.9-4.5-7.2-7.2,2.8,2.1,8.2,3.5,11.6,4,1.1,1.9,3.6,3.5,5.7,3.4",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,95.5c-2.7,6-10.3,9.5-13.3,15.4,0-.3-.1-.7-.2-1",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.8,95.8c.2-5.2-2.3-10.1-4.7-14.7",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,95.5c-2-.1-5.7.7-7.5,1.4-.7.3-1.4.7-2.2,1-1.9.7-4,.7-6,.6-1.1,0-2.2,0-3.2-.4s-2-1-2.4-2",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.5,95.5c1.6-1.1,4.4-2.7,6.1-3.8.9-.6,1.9-1.2,3-1.4.7,0,1.5,0,2.2.2,2.6.6,6.2,1.3,8.7,1.9",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageMatrix);
export default __webpack_public_path__ + "static/media/damageMatrix.fe51aecb33d7eb9d11a382ad7403b06b.svg";
export { ForwardRef as ReactComponent };